import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

interface FormDeleteButtonProps {
  onClickDialogAction?: () => void;
  /** Trigger button text. Defaults to the destructive "Delete" wording. */
  label?: string;
  title?: string;
  description?: string;
  actionLabel?: string;
}

function FormDeleteButton({
  onClickDialogAction,
  label = 'Delete',
  title,
  description,
  actionLabel,
}: FormDeleteButtonProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="text-feedback-error border-feedback-error hover:text-feedback-error"
        >
          {label}
        </Button>
      </AlertDialogTrigger>
      <DeleteAlert
        onClickDialogAction={onClickDialogAction}
        title={title}
        description={description}
        actionLabel={actionLabel}
      />
    </AlertDialog>
  );
}

interface DeleteAlertProps {
  onClickDialogAction?: () => void;
  title?: string;
  description?: string;
  actionLabel?: string;
}

export function DeleteAlert({
  onClickDialogAction,
  title = 'Are You Sure You Want to Delete This?',
  description = 'Deleting this will remove it permanently. Take a moment to double-check before continuing.',
  actionLabel = 'Delete',
}: DeleteAlertProps) {
  return (
    <AlertDialogContent>
      <AlertDialogHeader className="flex items-center gap-6">
        <Trash2 strokeWidth={1} className="size-8" />
        <div className="flex flex-col gap-2">
          <AlertDialogTitle className="text-text-primary text-center text-lg font-semibold">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-text-tertiary text-center text-sm">
            {description}
          </AlertDialogDescription>
        </div>
      </AlertDialogHeader>

      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction
          className="bg-feedback-error hover:bg-red-600"
          onClick={onClickDialogAction}
        >
          {actionLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
}

export { FormDeleteButton };
